export const environment = {
    okta: {
        issuer: 'https://marsh-mmc.oktapreview.com/oauth2/default',
        clientId: '0oa2mes9v57Z0ou8S0h8',
        redirectUri: window.location.origin + '/LoginCallback',
        postLogoutRedirectUri: window.location.origin + '/LogoutCallback',
        scopes: ['openid', 'profile', 'email'],
        pkce: true
    },
    allowedOrigins: ['https://stgcredi-link.africa.marsh.com'],
    apiBaseUrl: 'https://app-credilink-primary-san-api-staging.azurewebsites.net'
};